import { render, staticRenderFns } from "./brandAuthorization.vue?vue&type=template&id=6cbc52fa&scoped=true"
import script from "./brandAuthorization.vue?vue&type=script&lang=js"
export * from "./brandAuthorization.vue?vue&type=script&lang=js"
import style0 from "./brandAuthorization.vue?vue&type=style&index=0&id=6cbc52fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc52fa",
  null
  
)

export default component.exports